import { render, staticRenderFns } from "./WechatLoginDialog.vue?vue&type=template&id=118c0182&scoped=true"
import script from "./WechatLoginDialog.vue?vue&type=script&lang=js"
export * from "./WechatLoginDialog.vue?vue&type=script&lang=js"
import style0 from "./WechatLoginDialog.vue?vue&type=style&index=0&id=118c0182&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c0182",
  null
  
)

export default component.exports